<template>
  <div class="p-call">
    <!-- 受付を読み込めなかったとき（REC-443）。キャストが取れる行動だけを書く。
         リンクを断られた理由（期限切れ・古いリンクなど）は管理システムが返さない -->
    <div class="p-call__wrap" v-if="loadError">
      <div class="p-call__form">
        <template v-if="loadError == 'link'">
          <div class="p-call__txt01 red">このリンクは使えません</div>
          <div class="p-call__txt01">
            リンクの有効期限が切れているか、<br />
            古いリンクの可能性があります。<br /><br />
            お手数ですが、お店にご連絡ください。
          </div>
        </template>
        <template v-else>
          <div class="p-call__txt01 red">通信できませんでした</div>
          <div class="p-call__txt01">
            電波の良いところで、<br />
            もう一度開いてください。<br /><br />
            続くときは、お店にご連絡ください。
          </div>
        </template>
      </div>
    </div>
    <!-- 部屋番号の確認（REC-226）。
         詳細に行き先と部屋番号が出るので、その手前で確認していただき、
         押した時刻を店舗側に記録する。**開くたびに出す。**
         使っていない店舗ではサーバが false を返すので、そのまま詳細へ進む -->
    <div class="p-call__wrap" v-else-if="showConfirmGate">
      <div class="p-call__form">
        <div class="p-call__row">
          <div class="p-call__txt01">詳細を確認します</div>
        </div>
        <div class="p-call__row">
          <div class="p-call__txt03">
            下のボタンを押すと、行き先と部屋番号が表示されます。
          </div>
        </div>
        <input
          type="button"
          class="p-call__button p-call__button-green top"
          v-on:click="clickConfirmRoomNumber()"
          value="詳細を確認します"
        />
      </div>
    </div>
    <!-- **v-show ではなく v-else。** v-show は隠すだけでDOMは作られるので、
         ボタンを押さなくても開発者ツールから部屋番号を読めてしまい、
         押した記録を残すという目的が果たせない -->
    <div class="p-call__wrap" v-else>
      <div class="p-call__form">
        <div class="p-call__row" v-show="!isDelivery">
          <div class="p-call__txt02">来店区分</div>
          <div class="p-call__txt03">
            ： {{ order_item.visit_status == 1 ? "来店" : ""
            }}<span class="big">{{
              order_item.delivery_flg == 1 && order_item.visit_status != 1
                ? "デリバリー"
                : order_item.visit_status == 2
                ? "直ホ"
                : ""
            }}</span>
          </div>
        </div>
        <div class="p-call__row" v-show="isDelivery">
          <div class="p-call__txt02">キャスト料金受取</div>
          <div class="p-call__txt03">
            ： {{ order_item.cast_payment_receive_flg == 1 ? "必要" : "不要" }}
          </div>
        </div>
        <div class="p-call__row">
          <div class="p-call__txt02">女の子</div>
          <div class="p-call__txt03">
            ：
            {{ order_item.cast_name }}
          </div>
        </div>
        <div class="p-call__row">
          <div class="p-call__txt02">予約時間</div>
          <div class="p-call__txt03">
            ： {{ getStrDateTime(order_item.time_from) }}~
          </div>
        </div>
        <div class="p-call__row" v-show="dataStatus == 3">
          <div class="p-call__txt02">インコール時間</div>
          <div class="p-call__txt03">
            ：
            {{ order_item.time_incall }}
          </div>
        </div>
        <div class="p-call__row">
          <div class="p-call__txt02">区分</div>
          <div class="p-call__txt03">
            ：
            {{ order_item.member_join == "1" ? "新規" : "会員" }}
          </div>
        </div>
        <div class="p-call__row">
          <div class="p-call__txt02">コース</div>
          <div class="p-call__txt03">
            ：
            {{
              Number(order_item.course_time) + Number(order_item.extension)
            }}分
          </div>
        </div>
        <div class="p-call__row">
          <div class="p-call__txt02">指名区分</div>
          <div class="p-call__txt03">
            ：
            {{ order_item.choice }}
          </div>
        </div>
        <div class="p-call__row">
          <div class="p-call__txt02">オプション</div>
          <div class="p-call__txt03">
            ：
            {{ option }}
          </div>
        </div>
        <div class="p-call__row">
          <div class="p-call__txt02">お名前</div>
          <div class="p-call__txt03">：{{ order_item.master_name }}様</div>
        </div>
        <div class="p-call__row">
          <div class="p-call__txt02">ホテル</div>
          <div class="p-call__txt03">
            ：
            {{ hotel }}
          </div>
        </div>
        <div class="p-call__row">
          <div class="p-call__txt02">部屋番号</div>
          <div class="p-call__txt03">
            ：
            {{ order_item.hotel_room ? order_item.hotel_room + "号室" : "" }}
          </div>
        </div>
        <div class="p-call__row" v-show="order_item.visit_status != 1">
          <div class="p-call__txt02">現金支払</div>
          <div class="p-call__txt03">
            ：
            {{ Number(order_item.payment_amount) | priceLocaleString }}
          </div>
        </div>
        <div
          class="p-call__row"
          v-show="
            order_item.visit_status != 1 &&
            Number(order_item.payment_card_amount) > 0
          "
        >
          <div class="p-call__txt02">カード支払</div>
          <div class="p-call__txt03">
            ：
            {{
              (Number(order_item.payment_card_amount) -
                Number(order_item.payment_method_price))
                | priceLocaleString
            }}
          </div>
        </div>
        <div class="p-call__row" v-show="order_item.visit_status != 1">
          <div class="p-call__txt02">お釣り</div>
          <div class="p-call__txt03">
            ：
            {{
              (Number(order_item.payment_change) -
                (order_item.payment_card_amount
                  ? Number(order_item.payment_card_amount) -
                    Number(order_item.payment_method_price)
                  : 0))
                | priceLocaleString2
            }}
          </div>
        </div>
        <input type="hidden" name="sheet_id" />
        <input type="hidden" name="detail_id" :value="order_item.store_id" />
      </div>
      <div class="p-call__error">
        <!-- 同意の案内は errorMessage と分ける（REC-128）。インコールと**並行して走る**
             会員番号の採番が errorMessage を書き換えるので、同じ箱に入れると消える -->
        <div v-if="consentMessage">{{ consentMessage }}</div>
        {{ errorMessage }}
      </div>
      <div class="p-call__txt01" v-show="dataStatus == 3">
        一度このページを閉じて<br />アウトコールの際は再度このページを開いてください。<br /><br />
        お客様が延長をご希望の場合は、<br />女の子からお店の方にお電話をお願いします。
      </div>
      <div class="p-call__txt01 red" v-show="!order_item.id">
        受付データが存在しません。<br />
        既に削除された可能性があります。
      </div>
      <div
        class="p-call__txt01"
        v-if="dataStatus == 2 && inCallOrderFlg == true"
      >
        以下の受付がアウトコールがされていないため、<br />インコール出来ません。<br />
        <br />
        {{ incall_item.member_name }}様<br />
        {{ incall_item.time_from }}～<br /><br />
        <a :href="inCallOrderUrl">コール画面へ移動</a>
      </div>
      <input
        type="button"
        class="p-call__button p-call__button-gray top"
        v-show="dataStatus == 0 || dataStatus == 1"
        value="精算前のため、インコール出来ません"
      />
      <!-- 誓約書の同意がまだ（REC-128）。**アウトコール未済より先に出す。**
           同意はもらうのに時間がかかるので、確定した時点から見えていた方が手を打てる。
           上の「以下の受付がアウトコールがされていないため〜」の説明は今までどおり出るので、
           両方の事情が同時に読める -->
      <input
        type="button"
        class="p-call__button p-call__button-red top"
        v-show="dataStatus == 2 && consentBlocked"
        disabled
        value="誓約書 未確認"
      />
      <input
        type="button"
        class="p-call__button p-call__button-orange top"
        v-on:click="inCallPopupOpen()"
        v-show="dataStatus == 2 && !inCallOrderFlg && !consentBlocked"
        value="インコール"
      />
      <input
        type="button"
        class="p-call__button p-call__button-gray top"
        v-show="dataStatus == 2 && inCallOrderFlg && !consentBlocked"
        value="インコール出来ません"
      />
      <input
        type="button"
        class="p-call__button p-call__button-green top"
        v-on:click="outCallPopupOpen()"
        v-show="dataStatus == 3"
        value="アウトコール"
      />
      <input
        type="button"
        class="p-call__button p-call__button-gray"
        v-on:click="inCallCancelPopupOpen()"
        v-show="dataStatus == 3"
        value="インコール取り消し"
      />
      <input
        type="button"
        class="p-call__button p-call__button-gray top"
        v-on:click="outCallCancelPopupOpen()"
        v-show="dataStatus == 4 && !order_item.past"
        value="アウトコール取り消し"
      />
      <input
        type="button"
        class="p-call__button p-call__button-red top02"
        v-on:click="helpCallPopupOpen()"
        v-show="
          (!helpCallStatus || helpCallStatus == 0) &&
          order_item.id &&
          !order_item.past
        "
        value="ヘルプコール"
      />
      <input
        type="button"
        class="p-call__button p-call__button-gray top02 red"
        v-on:click="helpCallPopupOpen()"
        v-show="helpCallStatus == 1 || helpCallStatus == 2"
        value="※ ヘルプコール中です ※"
      />
    </div>
    <popupComponent
      v-show="inCallPopupFlg"
      :confirmTxt="confirmMessage"
      :buttonTxt="'はい'"
      :buttonClick="clickInCall"
      :confirmTxtColor="'black'"
      :cancelClick="inCallPopupCancel"
      :buttonColor="'orange'"
    ></popupComponent>
    <popupComponent
      v-show="inCallCancelPopupFlg"
      :confirmTxt="confirmMessage"
      :buttonTxt="'はい'"
      :buttonClick="clickInCallCancel"
      :confirmTxtColor="'red'"
      :cancelClick="inCallCancelPopupCancel"
      :buttonColor="'red'"
    ></popupComponent>
    <popupComponent
      v-show="outCallPopupFlg"
      :confirmTxt="confirmMessage"
      :buttonTxt="'はい'"
      :buttonClick="clickOutCall"
      :confirmTxtColor="'black'"
      :cancelClick="outCallPopupCancel"
      :buttonColor="'green'"
    ></popupComponent>
    <popupComponent
      v-show="outCallCancelPopupFlg"
      :confirmTxt="confirmMessage"
      :buttonTxt="'はい'"
      :buttonClick="clickOutCallCancel"
      :confirmTxtColor="'red'"
      :cancelClick="outCallCancelPopupCancel"
      :buttonColor="'red'"
    ></popupComponent>
    <helpComponent
      v-show="helpcallPopupFlg"
      :confirmTxt="confirmMessage"
      :buttonTxt="'はい'"
      :buttonLineClick="clickHelpLine"
      :buttonTellClick="clickHelpTell"
      :buttonCancelClick="clickHelpCancel"
      :confirmTxtColor="'red'"
      :cancelClick="helpCallPopupCancel"
      :buttonColor="'red'"
    ></helpComponent>
    <div class="p-call__loading" :class="{ active: loadingFlg }">
      <div class="p-call__loading_inner">
        <div class="p-call__loading_txt01">Ultra Group</div>
        <div class="p-call__loading_img01">
          <img class="u-image-w" src="../../assets/image/loading.gif" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helpComponent from "./popup/HelpCallPopupComponent.vue";
import popupComponent from "./popup/PopupComponent.vue";
import axios from "axios";
import {
  describeError,
  isLinkRefused,
  isNetworkError,
  orderFormUrl,
  withToken,
} from "../../lib/signedLink";

/* 管理システムがリンクを断ったとき（REC-443）。理由は返ってこない（どれも同じ 404）ので、
   キャストが取れる行動（お店へ連絡）だけを伝える */
const LINK_REFUSED_ACTION =
  "リンクの有効期限が切れているため、記録できませんでした。お手数ですが、お店にご連絡ください。";

export default {
  name: "Form",
  components: {
    helpComponent,
    popupComponent,
  },
  filters: {
    /* 3桁ごとにカンマを付与 */
    priceLocaleString(value) {
      if (value || value == 0) {
        return Number(value).toLocaleString() + "円";
      } else {
        return "";
      }
    },
    /* 3桁ごとにカンマを付与 */
    priceLocaleString2(value) {
      if (value) {
        return Number(value).toLocaleString() + "円";
      } else {
        return "";
      }
    },
  },
  data: function () {
    return {
      order_item: {},
      option: "",
      catch_allocation_detail: {},
      incall_item: {},
      pageFlg: true,
      hotel: "",
      errorMessage: "",
      /* 未同意の誓約書の表示名（REC-128）。空ならインコールを押せる */
      consentPending: [],
      /* 同意がまだで断られたときの案内（REC-128）。`errorMessage` とは別に持つ */
      consentMessage: "",
      timeFromHour: "",
      timeFromMinutes: "",
      dataStatus: "",
      helpCallStatus: "",
      execOrderId: "",
      orderId: "",
      storeId: "",
      confirmMessage: "",
      inCallOrderFlg: false,
      inCallOrderUrl: "",
      inCallPopupFlg: false,
      inCallCancelPopupFlg: false,
      outCallPopupFlg: false,
      outCallCancelPopupFlg: false,
      helpcallPopupFlg: false,
      loadingFlg: true,
      isDelivery: false,
      /* サーバが「確認画面を出す店舗か」を返す。判定は画面に持たない */
      confirmRequired: false,
      /* この画面で確認を押したか。**保存しない**ので、開き直せばまた出る */
      confirmed: false,
      /* 記録の送信中か。続けて押されても1回に留める */
      confirmSending: false,
      /* 受付を読み込めなかった理由（REC-443）。"link" はリンクを断られた、
         "network" は応答が無かった。空なら読み込めている（または従来どおりの表示） */
      loadError: "",
    };
  },
  created() {
    this.orderId = this.$route.query.o;
    this.storeId = this.$route.query.s;
    this.getInfo(this.orderId, this.storeId);
    this.inCallPopupFlg = false;
    this.inCallCancelPopupFlg = false;
    this.outCallPopupFlg = false;
    this.outCallCancelPopupFlg = false;
    if (
      this.storeId == "selection" ||
      this.storeId == "happiness" ||
      this.storeId == "celebrity" ||
      this.storeId == "galaxy" ||
      this.storeId == "blaze"
    ) {
      this.isDelivery = true;
    }
  },
  computed: {
    /**
     * 管理システムのAPI。
     *
     * **ビルド時の環境変数で差し替える。** 未設定なら本番。
     * テスト環境向けのビルドでだけ VUE_APP_API_BASE_URL を渡す。
     * 直接書いていたころは、テスト環境用に配信しても本番のAPIを見ていた。
     */
    apiUrl() {
      /* Amplify の設定欄は前後の空白や改行が混ざりやすい。そのままだと
         リクエスト先が壊れて全滅するので、先に落としてから既定値と比べる。
         空白だけのときも「未設定」と同じ扱いにして本番へ倒す */
      const configured = (process.env.VUE_APP_API_BASE_URL || "").trim();
      const base = configured || "https://manage.ug-system.net";

      return base.replace(/\/+$/, "") + "/api/call";
    },
    /**
     * 誓約書の同意がまだ残っているか（REC-128）。
     *
     * サーバ（`post_type: 5`）が未同意の書類の**表示名だけ**を返す。
     * 止めない設定（record）のあいだは空で届くので、ここも素通りになる。
     */
    consentBlocked() {
      return this.consentPending.length > 0;
    },
    /**
     * 確認画面を出すか。**押すまでは詳細を見せない。**
     * 使っていない店舗ではサーバが false を返すので、そのまま詳細へ進む。
     * 読み込み中は出さない（判定が届く前に一瞬出てしまうため）
     */
    showConfirmGate() {
      return this.confirmRequired && !this.confirmed && !this.loadingFlg;
    },
  },
  methods: {
    /**
     * 部屋番号を確認したことを店舗側へ記録してから、詳細を表示する。
     *
     * **記録できなくても詳細は見せる。** この画面はキャストが仕事で使う道具なので、
     * 記録の失敗で行き先が分からなくなるほうが困る。失敗はログに残す
     */
    clickConfirmRoomNumber() {
      /* 続けて押されても記録は1回。押している間は待っていることが分かるよう
         既存の読み込み表示を出す */
      if (this.confirmSending) {
        return;
      }
      this.confirmSending = true;
      this.loadingFlg = true;

      const request = {
        post_type: 6,
        order_id: this.orderId,
      };
      this.postCall(request, {
        /* **既定は無制限。** 応答が返らないと押しても何も起きない画面になり、
           「記録できなくても詳細は見せる」という約束が果たせない */
        timeout: 10000,
      })
        .catch((error) => {
          /* リンクを断られた（404）ときも詳細は見せる。詳細は同じリンクで
             もう読めているので、ここで隠しても守れるものが無い */
          console.error(
            "部屋番号の確認を記録できませんでした。",
            describeError(error)
          );
        })
        .then(() => {
          this.confirmSending = false;
          this.loadingFlg = false;
          this.confirmed = true;
        });
    },
    getStrDateTime(datetime) {
      if (datetime) {
        return datetime.substr(11, 5);
      }
      return "";
    },
    setTime(time) {
      let timeList = time.split(":");
      this.timeFromHour = Number(timeList[0]);
      this.timeFromMinutes = Number(timeList[1]);
    },
    getInfo(order_id, store_id) {
      const request = {
        store_id: store_id,
        post_type: 5,
        order_id: order_id,
      };
      this.postCall(request)
        .then((res) => {
          this.order_item = res.data.order_item;
          this.confirmRequired = res.data.room_number_confirm_required === true;
          this.consentPending = Array.isArray(res.data.consent_pending)
            ? res.data.consent_pending
            : [];
          this.consentMessage = "";
          this.option = res.data.option;
          this.catch_allocation_detail = res.data.catch_allocation_detail;
          this.incall_item = res.data.incall_item;
          this.dataStatus = this.order_item.data_status;
          this.helpCallStatus = this.order_item.help_call_status;
          this.execOrderId = this.order_item.id;
          if (this.order_item.delivery_flg == 1) {
            this.hotel =
              this.order_item.delivery_address_flg == 1
                ? "自宅"
                : this.order_item.delivery_hotel;
          } else {
            this.hotel = this.order_item.hotel;
          }
          if (this.incall_item) {
            this.inCallOrderFlg = true;
            /* 前の受付は別の注文なので、このリンクのトークンは使えない。
               管理システムが渡すその受付用のトークンを載せる（REC-573） */
            this.inCallOrderUrl = orderFormUrl(
              location.protocol + "//" + location.hostname,
              this.incall_item.store_id,
              this.incall_item.id,
              res.data.incall_item_token
            );
          }
          this.loadingFlg = false;
        })
        .catch((error) => {
          console.log("受付を読み込めませんでした。", describeError(error));
          /* リンクを断られたときと届かなかったときは、詳細の枠を出さずに案内だけ出す。
             空の詳細と「受付データが存在しません」が出ると、受付が消えたように見える */
          if (isLinkRefused(error)) {
            this.loadError = "link";
          } else if (isNetworkError(error)) {
            this.loadError = "network";
          }
          this.loadingFlg = false;
        });
    },
    /**
     * `/api/call` へ送る。**この画面からの送信はすべてここを通す。**
     *
     * リンクのトークンを本文の `t` に付ける（REC-443）。付けるのはリンクと同じ注文への
     * 送信だけ。トークンが無ければ本文は今までと同じ。
     */
    postCall(request, config) {
      return axios.post(
        this.apiUrl,
        withToken(request, request.order_id),
        config
      );
    },
    /**
     * 操作（インコール・アウトコール・ヘルプコールなど）が失敗したときに出す文言。
     * リンクを断られたときだけ案内に置き換え、それ以外はこれまでどおり。
     */
    actionErrorMessage(error) {
      return isLinkRefused(error) ? LINK_REFUSED_ACTION : error;
    },
    /**
     * インコール処理
     * @return
     */
    clickInCall() {
      this.loadingFlg = true;
      const request = {
        post_type: 1,
        store_id: this.order_item.store_id,
        order_id: this.execOrderId,
        data_status: 3,
        time_incall: this.getStrTime(),
      };
      this.postCall(request)
        .then((res) => {
          this.order_item.time_incall = res.data.time_incall;
          this.dataStatus = res.data.data_status;
          this.errorMessage = "";
          this.consentMessage = "";
          this.consentPending = [];
          this.inCallPopupFlg = false;
          this.loadingFlg = false;
        })
        .catch((error) => {
          /* 断られた理由を出す（REC-128）。`error` のままだと
             「Request failed with status code 409」としか出ない。
             **ボタンもその場で切り替える**（応答に未同意の書類が載っている）。

             同意の案内だけ `consentMessage` に入れるのは、**この下の会員番号の採番が
             並行して走り、成否にかかわらず `errorMessage` を書き換える**ため。
             同じ箱に入れると案内が消える。採番の側は触らないので、
             同意以外の失敗の出方はこれまでと変わらない */
          const data = error && error.response ? error.response.data : null;
          const pending =
            data && Array.isArray(data.consent_pending)
              ? data.consent_pending
              : [];
          if (pending.length) {
            this.consentPending = pending;
            this.consentMessage = (data && data.message) || "";
          } else if (isLinkRefused(error)) {
            /* 断った応答にも `message` は載るが、キャスト向けの言葉ではない（REC-443） */
            this.errorMessage = LINK_REFUSED_ACTION;
          } else {
            this.errorMessage = (data && data.message) || error;
          }
          this.inCallPopupFlg = false;
          this.loadingFlg = false;
        });

      /* 会員番号自動付番 */
      if (
        this.order_item.master_code == 0 ||
        this.order_item.master_code == "0000" ||
        this.order_item.master_code == ""
      ) {
        let codeRequest = {
          post_type: 3,
          store_id: this.order_item.store_id,
          order_id: this.order_item.id,
          member_id: this.order_item.member_id,
          category_id: "",
        };
        this.postCall(codeRequest)
          .then((res) => {
            this.order_item.master_code = res.data.code;
            this.errorMessage = "";
          })
          .catch((error) => {
            this.errorMessage = this.actionErrorMessage(error);
          });
      }
      this.inCallPopupFlg = false;
    },
    /**
     * インコール取り消し処理
     * @return
     */
    clickInCallCancel() {
      this.loadingFlg = true;
      const request = {
        post_type: 1,
        store_id: this.order_item.store_id,
        order_id: this.execOrderId,
        data_status: 2,
      };
      this.postCall(request)
        .then((res) => {
          this.order_item.time_outcall = "";
          this.dataStatus = res.data.data_status;
          this.errorMessage = "";
          this.loadingFlg = false;
        })
        .catch((error) => {
          this.errorMessage = this.actionErrorMessage(error);
          this.loadingFlg = false;
        });
      this.inCallCancelPopupFlg = false;
    },
    /**
     * アウトコール処理
     * @return
     */
    clickOutCall() {
      this.loadingFlg = true;
      const request = {
        post_type: 2,
        store_id: this.order_item.store_id,
        order_id: this.execOrderId,
        data_status: 4,
        time_outcall: this.getStrTime(),
      };
      this.postCall(request)
        .then((res) => {
          this.order_item.time_outcall = res.data.time_outcall;
          this.dataStatus = res.data.data_status;
          this.errorMessage = "";
          this.loadingFlg = false;
        })
        .catch((error) => {
          this.errorMessage = this.actionErrorMessage(error);
          this.loadingFlg = false;
        });
      this.outCallPopupFlg = false;
    },
    /**
     * アウトコール取り消し処理
     * @param  {String} orderId 注文ID
     * @return
     */
    clickOutCallCancel() {
      this.loadingFlg = true;
      const request = {
        post_type: 2,
        store_id: this.order_item.store_id,
        order_id: this.execOrderId,
        data_status: 3,
      };
      this.postCall(request)
        .then((res) => {
          this.order_item.time_outcall = "";
          this.dataStatus = res.data.data_status;
          this.errorMessage = "";
          this.loadingFlg = false;
        })
        .catch((error) => {
          this.errorMessage = this.actionErrorMessage(error);
          this.loadingFlg = false;
        });
      this.outCallCancelPopupFlg = false;
    },
    inCallPopupOpen() {
      this.confirmMessage = "";
      /* デリバリー店舗以外の場合 */
      // デリバリーの場合
      if (!this.isDelivery && this.order_item.delivery_flg == 1) {
        this.confirmMessage =
          this.confirmMessage +
          "<span>ご新規様の場合、\nスタッフが受け取っている場合がありますので\nお金受け取りは不要になります。</span>\n\n";
      }
      if (!this.isDelivery) {
        this.confirmMessage =
          this.confirmMessage +
          "お客様からレシートを受け取り\n注文内容と相違はありませんか？";
      }
      let change =
        Number(this.order_item.payment_change) -
        (Number(this.order_item.payment_card_amount) > 0
          ? Number(this.order_item.payment_card_amount) -
            Number(this.order_item.payment_method_price)
          : 0);
      /* 直ホの場合 */
      if (!this.isDelivery && this.order_item.visit_status == 2) {
        if (change > 0) {
          this.confirmMessage =
            this.confirmMessage +
            "\n\nお預かり" +
            Number(this.order_item.payment_deposit).toLocaleString() +
            "円\n";
          this.confirmMessage =
            this.confirmMessage + "お釣り " + change + "円\n";
          this.confirmMessage =
            this.confirmMessage +
            Number(change).toLocaleString() +
            "円のお返しをお願いします。";
        } else {
          this.confirmMessage =
            this.confirmMessage + "\n\nお釣り " + change + "円";
        }
      }
      /* デリバリー店舗で受取不要の場合 */
      if (
        this.isDelivery &&
        Number(this.order_item.cast_payment_receive_flg) != 1
      ) {
        this.confirmMessage =
          this.confirmMessage +
          "<span>お金受け取りは不要になります。</span>\n\n";
      }
      /* デリバリー店舗で受取が必要の場合 */
      if (
        this.isDelivery &&
        Number(this.order_item.cast_payment_receive_flg) == 1
      ) {
        if (change > 0) {
          this.confirmMessage =
            this.confirmMessage +
            "\n\nお預かり" +
            Number(this.order_item.payment_deposit).toLocaleString() +
            "円\n";
          this.confirmMessage =
            this.confirmMessage + "お釣り " + change + "円\n";
          this.confirmMessage =
            this.confirmMessage +
            Number(change).toLocaleString() +
            "円のお返しをお願いします。";
        } else {
          this.confirmMessage =
            this.confirmMessage +
            "\n\nお預かり" +
            Number(this.order_item.payment_deposit).toLocaleString() +
            "円\n";
          this.confirmMessage =
            this.confirmMessage + "\n受け取りお願い致します。";
        }
      }
      this.inCallPopupFlg = true;
    },
    inCallCancelPopupOpen() {
      this.confirmMessage = "インコールを取り消します\n本当によろしいですか？";
      this.inCallCancelPopupFlg = true;
    },
    outCallPopupOpen() {
      this.confirmMessage = "";
      /* 直ホの場合 */
      if (this.order_item.visit_status == 2) {
        let change =
          Number(this.order_item.payment_change) -
          (Number(this.order_item.payment_card_amount) > 0
            ? Number(this.order_item.payment_card_amount) -
              Number(this.order_item.payment_method_price)
            : 0);
        this.confirmMessage =
          "お金の受け取りは大丈夫ですか？\nお預かり " +
          Number(this.order_item.payment_deposit).toLocaleString() +
          "円\n";
        this.confirmMessage =
          this.confirmMessage +
          "お釣り " +
          Number(change).toLocaleString() +
          "円\n\n";
      }
      this.confirmMessage =
        this.confirmMessage +
        "<span>お別れしたらお店にお電話をお願いします。</span>";
      this.outCallPopupFlg = true;
    },
    outCallCancelPopupOpen() {
      this.confirmMessage =
        "アウトコールを取り消します\n本当によろしいですか？";
      this.outCallCancelPopupFlg = true;
    },
    helpCallPopupOpen() {
      this.confirmMessage =
        "お店からすぐにご連絡させてもらいます。\nどちらの方法で連絡を希望されますか？";
      this.helpcallPopupFlg = true;
    },
    inCallPopupCancel() {
      this.inCallPopupFlg = false;
    },
    inCallCancelPopupCancel() {
      this.inCallCancelPopupFlg = false;
    },
    outCallPopupCancel() {
      this.outCallPopupFlg = false;
    },
    outCallCancelPopupCancel() {
      this.outCallCancelPopupFlg = false;
    },
    helpCallPopupCancel() {
      this.helpcallPopupFlg = false;
    },
    /**
     * LINEヘルプコール処理
     * @return
     */
    clickHelpLine() {
      this.loadingFlg = true;
      const request = {
        post_type: 4,
        store_id: this.order_item.store_id,
        order_id: this.execOrderId,
        help_call_status: 1,
      };
      this.postCall(request)
        .then((res) => {
          this.helpCallStatus = res.data.help_call_status;
          this.errorMessage = "";
          this.loadingFlg = false;
        })
        .catch((error) => {
          this.errorMessage = this.actionErrorMessage(error);
          this.loadingFlg = false;
        });
      this.helpcallPopupFlg = false;
    },
    /**
     * 電話ヘルプコール処理
     * @return
     */
    clickHelpTell() {
      this.loadingFlg = true;
      const request = {
        post_type: 4,
        store_id: this.order_item.store_id,
        order_id: this.execOrderId,
        help_call_status: 2,
      };
      this.postCall(request)
        .then((res) => {
          this.helpCallStatus = res.data.help_call_status;
          this.errorMessage = "";
          this.loadingFlg = false;
        })
        .catch((error) => {
          console.log(describeError(error));
          this.errorMessage = this.actionErrorMessage(error);
          this.loadingFlg = false;
        });
      this.helpcallPopupFlg = false;
    },
    /**
     * ヘルプコール取り消し処理
     * @return
     */
    clickHelpCancel() {
      this.loadingFlg = true;
      const request = {
        post_type: 4,
        store_id: this.order_item.store_id,
        order_id: this.execOrderId,
        help_call_status: 0,
      };
      this.postCall(request)
        .then((res) => {
          this.helpCallStatus = res.data.help_call_status;
          this.errorMessage = "";
          this.loadingFlg = false;
        })
        .catch((error) => {
          this.errorMessage = this.actionErrorMessage(error);
          this.loadingFlg = false;
        });
      this.helpcallPopupFlg = false;
    },
    /**
     * 時刻を取得
     * @param  {String} date
     * @return
     */
    getStrTime(date) {
      let target_date = date ? date : new Date();
      return (
        String("0" + String(target_date.getHours())).slice(-2) +
        ":" +
        String("0" + String(target_date.getMinutes())).slice(-2)
      );
    },
    closeTab() {
      window.close();
    },
  },
};
</script>
